import React from "react";

const TransmissionOfShares = () => {
  return <div>TransmissionOfShares</div>;
};

export default TransmissionOfShares;
